export function TituloMenu(props) {
    return (
        <p style={{ fontSize: '0.8rem' }} className="select-none flex items-center font-semibold  text-white-100 w-3/5">
            {props.Titulo}
        </p>
    )
}